module.exports = {
  CopyMonthSetting: '設定＃セッテイ＃',
  FinanceSetting: '財務データの設定',
  HrSetting: 'HRデータ設定',
  MonthlyDataArchive: '月次データArchive',
  MonthlyFinance: '毎月の固定日(財務)',
  MonthlyHr: '毎月の固定日(HR)',
  MonthDataArchive: '月のデータArchive',
  WeeklyDay: '毎週',
  SetJudgmentCriteria: '差異判定条件の設定',
  ExportingData: 'データのエクスポート...',
  ExportActualAmountData: 'Accpacデータのエクスポート',
  ExportInvoiceData: 'Accpac請求書データのエクスポート',
  ExportBillingData: 'Accpac海外請求書データのエクスポート',
  SelectDataWithInvoiceNumber: '請求書番号のあるデータを選択してください。',
  SelectDataWithBillingNumber: '請求書番号のあるデータを選択してください。'
}
